import React from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useThemeContext } from "../../context/ThemeContext";

const CustomDatePicker = ({ label, value, onChange }) => {
  const { mode } = useThemeContext();
  const isDarkMode = mode === "dark";

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={value || null}
        onChange={onChange}
        slotProps={{
          textField: {
            sx: {
              width: "100%",
              minWidth: "150px",
              "& .MuiInputBase-root": {
                borderRadius: "8px",
                border: "1px solid #ccc",
                backgroundColor: isDarkMode ? "#333" : "#fff",
                "&:hover": { borderColor: "#4CAF50" },
                "&.Mui-focused": { borderColor: "#4CAF50", borderWidth: "2px" },
              },
              "& .MuiInputBase-input": { color: isDarkMode ? "#fff" : "#000" },
              "& .MuiInputLabel-root": { color: isDarkMode ? "#bbb" : "#666" },
              "& .MuiInputLabel-root.Mui-focused": { color: "#4CAF50" },
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
